import React from 'react';
import { useNavigate } from 'react-router-dom';

import HeaderUno from '../../Metodos/Compartidos/HeaderUno.js';

import {
    Cuerpo
} from '../../Css/StyledHeader.js';

import {
    HeaderTutorialesFijo,
    EspacioHeaderTutoriales
} from '../../Css/StyledTutoriales.js';

import {
    ManualMain,
    ManualVolver,

    ManualCabecera,
    ManualBadge,
    ManualTitulo,
    ManualBajada,
    ManualIntroduccion,

    ManualIndice,
    ManualIndiceTitulo,
    ManualIndiceGrid,
    ManualIndiceItem,
    ManualIndiceNumero,
    ManualIndiceTexto,

    ManualCapitulo,
    ManualCapituloNumero,
    ManualCapituloTitulo,
    ManualSubtitulo,
    ManualTexto,

    ManualPasos,
    ManualPaso,
    ManualPasoNumero,
    ManualPasoTexto,

    ManualClave,
    ManualImportante,
    ManualAdvertencia,

    ManualEjemplo,
    ManualEjemploTitulo,
    ManualEjemploFila,

    ManualDefiniciones,
    ManualDefinicion,
    ManualDefinicionTitulo,
    ManualDefinicionTexto,

    ManualCaso,
    ManualCasoPregunta,
    ManualCasoRespuesta,

    ManualResumen,
    ManualResumenFila,
    ManualResumenProblema,
    ManualResumenAccion,

    ManualImagen,
    ManualImagenPie,

    ManualSeparador
} from '../../Css/StyledManualCobros.js';


/*
====================================
MANUAL DE COBROS DE PACIENTES
====================================
*/

const ManualCobrosPacientes = () => {

    const navigate = useNavigate();


    /*
    ====================================
    IR A SECCIÓN
    ====================================
    */

    const irASeccion = (id) => {

        const elemento =
            document.getElementById(id);

        if (!elemento) {
            return;
        }

        elemento.scrollIntoView({
            behavior: 'smooth',
            block: 'start'
        });

    };


    /*
    ====================================
    ÍNDICE
    ====================================
    */

    const indice = [

        {
            id: 'como-se-genera-deuda',
            numero: '1',
            titulo: 'Cómo se genera una deuda'
        },

        {
            id: 'como-entrar',
            numero: '2',
            titulo: 'Cómo entrar a Estadísticas y cobros'
        },

        {
            id: 'como-leer-pantalla',
            numero: '3',
            titulo: 'Cómo leer la pantalla'
        },

        {
            id: 'encontrar-deudas',
            numero: '4',
            titulo: 'Cómo encontrar rápidamente quién te debe'
        },

        {
            id: 'registrar-cobro',
            numero: '5',
            titulo: 'Cómo registrar un cobro'
        },

        {
            id: 'historial-cobros',
            numero: '6',
            titulo: 'Cómo revisar y corregir un cobro'
        },

        {
            id: 'saldo-favor',
            numero: '7',
            titulo: 'Saldo a favor'
        },

        {
            id: 'no-cobrar',
            numero: '8',
            titulo: 'Prestaciones que no deben cobrarse'
        },

        {
            id: 'casos-frecuentes',
            numero: '9',
            titulo: 'Casos frecuentes'
        },

        {
            id: 'resumen-rapido',
            numero: '10',
            titulo: 'Resumen rápido'
        }

    ];


    /*
    ====================================
    VOLVER AL ÍNDICE
    ====================================
    */

    const renderVolverIndice = () => (

        <ManualVolver
            type="button"
            onClick={() =>
                irASeccion('indice')
            }
        >
            ↑ Volver al índice
        </ManualVolver>

    );


    /*
    ====================================
    RENDER
    ====================================
    */

    return (

        <Cuerpo>

            <HeaderTutorialesFijo>

                <HeaderUno />

            </HeaderTutorialesFijo>

            <EspacioHeaderTutoriales />

            <ManualMain>

                {/*
                ====================================
                VOLVER A TUTORIALES
                ====================================
                */}

                <ManualVolver
                    type="button"
                    onClick={() =>
                        navigate(
                            '/escritorio/tutoriales'
                        )
                    }
                >
                    ← Volver a Tutoriales
                </ManualVolver>


                {/*
                ====================================
                CABECERA
                ====================================
                */}

                <ManualCabecera>

                    <ManualBadge>
                        Guía paso a paso
                    </ManualBadge>

                    <ManualTitulo>
                        Gestión de cobros de pacientes
                    </ManualTitulo>

                    <ManualBajada>
                        Cómo registrar, controlar y corregir
                        los cobros de tus pacientes desde
                        el momento en que se crea una
                        prestación hasta que la cuenta queda
                        saldada.
                    </ManualBajada>

                </ManualCabecera>


                <ManualIntroduccion>

                    <p>
                        Esta guía explica el circuito económico
                        completo de un paciente dentro de
                        Método YÖGEN. No hace falta leerla
                        entera cada vez: podés usar el índice
                        para ir directamente al tema que
                        necesitás resolver.
                    </p>

                </ManualIntroduccion>


                {/*
                ====================================
                ÍNDICE
                ====================================
                */}

                <ManualIndice id="indice">

                    <ManualIndiceTitulo>
                        Índice
                    </ManualIndiceTitulo>

                    <ManualIndiceGrid>

                        {
                            indice.map(
                                (item) => (

                                    <ManualIndiceItem
                                        key={item.id}
                                        type="button"
                                        onClick={() =>
                                            irASeccion(
                                                item.id
                                            )
                                        }
                                    >

                                        <ManualIndiceNumero>
                                            {item.numero}
                                        </ManualIndiceNumero>

                                        <ManualIndiceTexto>
                                            {item.titulo}
                                        </ManualIndiceTexto>

                                    </ManualIndiceItem>

                                )
                            )
                        }

                    </ManualIndiceGrid>

                </ManualIndice>


                {/*
                ====================================
                CAPÍTULO 1
                ====================================
                */}

                <ManualCapitulo id="como-se-genera-deuda">

                    <ManualCapituloNumero>
                        Capítulo 1
                    </ManualCapituloNumero>

                    <ManualCapituloTitulo>
                        Cómo se genera una deuda
                    </ManualCapituloTitulo>

                    <ManualTexto>
                        La información económica no comienza
                        en <strong>Estadísticas y cobros</strong>.
                        El circuito comienza en el
                        <strong> Calendario</strong>.
                    </ManualTexto>

                    <ManualTexto>
                        Cuando creás un turno, podés indicar
                        cuánto corresponde cobrar por esa
                        prestación utilizando el campo
                        <strong> Honorarios</strong>.
                    </ManualTexto>

                    <ManualImagen>

                        <img
                            src="/img/tutoriales/cobros-pacientes/01-agregar-turno-superior.png"
                            alt="Agregar turno en el Calendario"
                        />

                        <ManualImagenPie>
                            Al crear un turno, primero completás el tipo de evento,
                            el paciente, el día, el horario y la modalidad.
                        </ManualImagenPie>

                    </ManualImagen>

                    <ManualSubtitulo>
                        Crear el turno
                    </ManualSubtitulo>

                    <ManualPasos>

                        <ManualPaso>
                            <ManualPasoNumero>
                                1
                            </ManualPasoNumero>

                            <ManualPasoTexto>
                                Entrá al <strong>Calendario</strong>
                                y seleccioná la opción para
                                <strong> Agregar turno</strong>.
                            </ManualPasoTexto>
                        </ManualPaso>

                        <ManualPaso>
                            <ManualPasoNumero>
                                2
                            </ManualPasoNumero>

                            <ManualPasoTexto>
                                Elegí el
                                <strong> Tipo de evento</strong>.
                                Por ejemplo:
                                <strong> Sesión con paciente</strong>.
                            </ManualPasoTexto>
                        </ManualPaso>

                        <ManualPaso>
                            <ManualPasoNumero>
                                3
                            </ManualPasoNumero>

                            <ManualPasoTexto>
                                Seleccioná el
                                <strong> Paciente</strong> y
                                completá <strong>Día</strong>,
                                <strong> Comienza</strong> y
                                <strong> Termina</strong>.
                            </ManualPasoTexto>
                        </ManualPaso>

                        <ManualPaso>
                            <ManualPasoNumero>
                                4
                            </ManualPasoNumero>

                            <ManualPasoTexto>
                                Completá la
                                <strong> Modalidad del turno</strong>
                                y, si corresponde, el
                                <strong> Consultorio / sede</strong>.
                            </ManualPasoTexto>
                        </ManualPaso>

                        <ManualPaso>
                            <ManualPasoNumero>
                                5
                            </ManualPasoNumero>

                            <ManualPasoTexto>
                                En <strong>Honorarios</strong>,
                                cargá el importe correspondiente
                                a esa prestación.
                            </ManualPasoTexto>
                        </ManualPaso>

                        <ManualPaso>
                            <ManualPasoNumero>
                                6
                            </ManualPasoNumero>

                            <ManualPasoTexto>
                                Completá el resto de los datos
                                necesarios y hacé clic en
                                <strong> CREAR</strong>.
                            </ManualPasoTexto>
                        </ManualPaso>

                    </ManualPasos>

                    <ManualImagen>

                        <img
                            src="/img/tutoriales/cobros-pacientes/02-agregar-turno-inferior.png"
                            alt="Honorarios y creación del turno"
                        />

                        <ManualImagenPie>
                            En Honorarios cargás el importe de la prestación.
                            Una vez completados los datos, seleccionás CREAR.
                        </ManualImagenPie>

                    </ManualImagen>

                    <ManualImportante>
                        <strong>Importante:</strong> crear el
                        turno no significa automáticamente
                        que esa prestación ya figure como
                        deuda. El turno inicialmente queda
                        pendiente.
                    </ManualImportante>


                    <ManualSubtitulo>
                        Cuando la prestación ocurrió
                    </ManualSubtitulo>

                    <ManualTexto>
                        Después de atender al paciente, abrí
                        nuevamente el turno desde el
                        Calendario.
                    </ManualTexto>

                    <ManualTexto>
                        En <strong>Estado del turno</strong>,
                        seleccioná <strong>Realizado</strong>
                        y luego hacé clic en
                        <strong> GUARDAR CAMBIOS</strong>.
                    </ManualTexto>

                    <ManualImagen>

                        <img
                            src="/img/tutoriales/cobros-pacientes/03-editar-turno-pendiente.png"
                            alt="Edición de un turno pendiente"
                        />

                        <ManualImagenPie>
                            Al editar un turno aparece Estado del turno.
                            Desde esta pantalla también podés ingresar a
                            ESTADÍSTICA Y COBROS.
                        </ManualImagenPie>

                    </ManualImagen>

                    <ManualImagen>

                        <img
                            src="/img/tutoriales/cobros-pacientes/04-turno-realizado.png"
                            alt="Turno marcado como Realizado"
                        />

                        <ManualImagenPie>
                            Cuando el turno está Realizado podés acceder también
                            a IR A HISTORIA CLÍNICA, además de ESTADÍSTICA Y COBROS.
                        </ManualImagenPie>

                    </ManualImagen>

                    <ManualClave>
                        <strong>Idea clave:</strong> al quedar
                        el turno <strong>Realizado</strong> y
                        tener <strong>Honorarios</strong>, la
                        prestación entra al circuito económico
                        del paciente.
                    </ManualClave>

                    <ManualEjemplo>

                        <ManualEjemploTitulo>
                            Ejemplo
                        </ManualEjemploTitulo>

                        <ManualEjemploFila>
                            <span>
                                Honorarios de la sesión
                            </span>

                            <strong>
                                $20.000
                            </strong>
                        </ManualEjemploFila>

                        <ManualEjemploFila>
                            <span>
                                Estado antes de atender
                            </span>

                            <strong>
                                Pendiente
                            </strong>
                        </ManualEjemploFila>

                        <ManualEjemploFila>
                            <span>
                                Estado después de atender
                            </span>

                            <strong>
                                Realizado
                            </strong>
                        </ManualEjemploFila>

                    </ManualEjemplo>


                    <ManualTexto>
                        Al editar un turno también podés
                        encontrar los estados
                        <strong> Cancelado</strong> y
                        <strong> No asistió</strong>.
                        Algunas de estas situaciones pueden
                        conservar un cargo económico.
                        Más adelante veremos cómo utilizar
                        <strong> Marcar como no cobrar</strong>
                        cuando corresponda.
                    </ManualTexto>


                    <ManualSubtitulo>
                        Turnos repetitivos
                    </ManualSubtitulo>

                    <ManualTexto>
                        Si el turno forma parte de una serie,
                        puede aparecer la opción
                        <strong>
                            {' '}
                            Aplicar cambios a esta serie desde
                            este turno en adelante
                        </strong>.
                    </ManualTexto>

                    <ManualTexto>
                        Esa opción permite extender determinados
                        cambios a los turnos posteriores de la
                        serie. Los turnos anteriores no se
                        modifican.
                    </ManualTexto>

                    {renderVolverIndice()}

                </ManualCapitulo>


                <ManualSeparador />


                {/*
                ====================================
                CAPÍTULO 2
                ====================================
                */}

                <ManualCapitulo id="como-entrar">

                    <ManualCapituloNumero>
                        Capítulo 2
                    </ManualCapituloNumero>

                    <ManualCapituloTitulo>
                        Cómo entrar a Estadísticas y cobros
                    </ManualCapituloTitulo>

                    <ManualTexto>
                        Podés acceder a
                        <strong> Estadísticas y cobros</strong>
                        de distintas maneras. No cambia la
                        información que vas a encontrar:
                        cambia solamente desde dónde llegás.
                    </ManualTexto>

                    <ManualImagen $ancho="angosto">

                        <img
                            src="/img/tutoriales/cobros-pacientes/05-menu-estadisticas-cobros.png"
                            alt="Acceso a Estadísticas y cobros desde el menú lateral"
                        />

                        <ManualImagenPie>
                            Desde el menú lateral podés ingresar directamente
                            a Estadísticas y cobros.
                        </ManualImagenPie>

                    </ManualImagen>

                    <ManualDefiniciones>

                        <ManualDefinicion>

                            <ManualDefinicionTitulo>
                                Desde el menú lateral
                            </ManualDefinicionTitulo>

                            <ManualDefinicionTexto>
                                Abrí el menú principal y
                                seleccioná
                                <strong>
                                    {' '}
                                    Estadísticas y cobros
                                </strong>.
                                Es la opción más útil cuando
                                querés revisar la situación
                                general de varios pacientes.
                            </ManualDefinicionTexto>

                        </ManualDefinicion>


                        <ManualDefinicion>

                            <ManualDefinicionTitulo>
                                Desde un paciente
                            </ManualDefinicionTitulo>

                            <ManualDefinicionTexto>
                                Entrá a
                                <strong> Pacientes</strong>,
                                abrí la ficha y, dentro de
                                <strong>
                                    {' '}
                                    Accesos del paciente
                                </strong>,
                                seleccioná
                                <strong>
                                    {' '}
                                    Estadísticas y cobros
                                </strong>.
                            </ManualDefinicionTexto>

                        </ManualDefinicion>


                        <ManualDefinicion>

                            <ManualDefinicionTitulo>
                                Desde un turno
                            </ManualDefinicionTitulo>

                            <ManualDefinicionTexto>
                                Abrí un turno desde el
                                <strong> Calendario</strong> y
                                utilizá el botón
                                <strong>
                                    {' '}
                                    ESTADÍSTICA Y COBROS
                                </strong>.
                            </ManualDefinicionTexto>

                        </ManualDefinicion>

                    </ManualDefiniciones>

                    <ManualImagen>

                        <img
                            src="/img/tutoriales/cobros-pacientes/06-acceso-desde-paciente.png"
                            alt="Acceso a Estadísticas y cobros desde el paciente"
                        />

                        <ManualImagenPie>
                            Si ya estás dentro de la ficha del paciente,
                            podés ingresar desde Accesos del paciente →
                            Estadísticas y cobros.
                        </ManualImagenPie>

                    </ManualImagen>

                    <ManualClave>
                        <strong>Atajo:</strong> si ya estás
                        trabajando con un paciente o con uno
                        de sus turnos, no necesitás volver al
                        menú principal.
                    </ManualClave>

                    {renderVolverIndice()}

                </ManualCapitulo>


                <ManualSeparador />


                {/*
                ====================================
                CAPÍTULO 3
                ====================================
                */}

                <ManualCapitulo id="como-leer-pantalla">

                    <ManualCapituloNumero>
                        Capítulo 3
                    </ManualCapituloNumero>

                    <ManualCapituloTitulo>
                        Cómo leer la pantalla
                    </ManualCapituloTitulo>

                    <ManualTexto>
                        Antes de mirar los números, revisá
                        siempre <strong>qué paciente</strong>
                        y <strong>qué período</strong> están
                        seleccionados.
                    </ManualTexto>

                    <ManualTexto>
                        Podés consultar
                        <strong> Todos los pacientes</strong>
                        o seleccionar un paciente específico.
                    </ManualTexto>

                    <ManualTexto>
                        También podés elegir:
                        <strong> Este mes</strong>,
                        <strong> Mes anterior</strong>,
                        <strong> Este año</strong> o
                        <strong> Personalizado</strong>.
                    </ManualTexto>

                    <ManualImagen>

                        <img
                            src="/img/tutoriales/cobros-pacientes/07-estadisticas-cobros-general.png"
                            alt="Pantalla principal de Estadísticas y cobros"
                        />

                        <ManualImagenPie>
                            La pantalla reúne información de asistencia,
                            dinero generado, dinero ingresado, deuda del período,
                            deuda anterior y saldo a favor.
                        </ManualImagenPie>

                    </ManualImagen>

                    <ManualSubtitulo>
                        Asistencia
                    </ManualSubtitulo>

                    <ManualDefiniciones>

                        <ManualDefinicion>
                            <ManualDefinicionTitulo>
                                Sesiones paciente
                            </ManualDefinicionTitulo>

                            <ManualDefinicionTexto>
                                Indica cuántas sesiones
                                computables hubo en el período
                                seleccionado.
                            </ManualDefinicionTexto>
                        </ManualDefinicion>

                        <ManualDefinicion>
                            <ManualDefinicionTitulo>
                                Presentismo paciente
                            </ManualDefinicionTitulo>

                            <ManualDefinicionTexto>
                                Muestra qué porcentaje de las
                                sesiones computables fueron
                                realizadas.
                            </ManualDefinicionTexto>
                        </ManualDefinicion>

                        <ManualDefinicion>
                            <ManualDefinicionTitulo>
                                Ausentismo paciente
                            </ManualDefinicionTitulo>

                            <ManualDefinicionTexto>
                                Muestra el porcentaje de
                                ausencias y diferencia las
                                situaciones registradas como
                                <strong> No asistió</strong> y
                                <strong> Canceladas</strong>.
                            </ManualDefinicionTexto>
                        </ManualDefinicion>

                        <ManualDefinicion>
                            <ManualDefinicionTitulo>
                                Total adeudado
                            </ManualDefinicionTitulo>

                            <ManualDefinicionTexto>
                                Es la deuda total actual:
                                <strong>
                                    {' '}
                                    Pendiente del período +
                                    Deuda anterior
                                </strong>.
                            </ManualDefinicionTexto>
                        </ManualDefinicion>

                    </ManualDefiniciones>


                    <ManualSubtitulo>
                        Los conceptos económicos
                    </ManualSubtitulo>

                    <ManualDefiniciones>

                        <ManualDefinicion>
                            <ManualDefinicionTitulo>
                                Generado
                            </ManualDefinicionTitulo>

                            <ManualDefinicionTexto>
                                Es el importe correspondiente
                                a las prestaciones del período
                                seleccionado que deben
                                cobrarse.
                            </ManualDefinicionTexto>
                        </ManualDefinicion>

                        <ManualDefinicion>
                            <ManualDefinicionTitulo>
                                Cobrado
                            </ManualDefinicionTitulo>

                            <ManualDefinicionTexto>
                                Indica qué parte de las
                                prestaciones generadas en el
                                período ya fue pagada,
                                independientemente de cuándo
                                entró el dinero.
                            </ManualDefinicionTexto>
                        </ManualDefinicion>

                        <ManualDefinicion>
                            <ManualDefinicionTitulo>
                                Ingresado
                            </ManualDefinicionTitulo>

                            <ManualDefinicionTexto>
                                Es el dinero que efectivamente
                                recibiste durante el período
                                seleccionado.
                            </ManualDefinicionTexto>
                        </ManualDefinicion>

                        <ManualDefinicion>
                            <ManualDefinicionTitulo>
                                Pendiente
                            </ManualDefinicionTitulo>

                            <ManualDefinicionTexto>
                                Es lo que todavía falta cobrar
                                de las prestaciones generadas
                                en el período seleccionado.
                            </ManualDefinicionTexto>
                        </ManualDefinicion>

                        <ManualDefinicion>
                            <ManualDefinicionTitulo>
                                Deuda anterior
                            </ManualDefinicionTitulo>

                            <ManualDefinicionTexto>
                                Es lo que todavía queda
                                pendiente de prestaciones
                                anteriores al período que
                                estás mirando.
                            </ManualDefinicionTexto>
                        </ManualDefinicion>

                        <ManualDefinicion>
                            <ManualDefinicionTitulo>
                                Saldo a favor
                            </ManualDefinicionTitulo>

                            <ManualDefinicionTexto>
                                Es dinero recibido del
                                paciente que todavía no fue
                                aplicado a ninguna deuda.
                            </ManualDefinicionTexto>
                        </ManualDefinicion>

                    </ManualDefiniciones>


                    <ManualClave>
                        <strong>Regla fácil:</strong>
                        <br />
                        <strong>Cobrado</strong> mira a qué
                        prestación pertenece el dinero.
                        <br />
                        <strong>Ingresado</strong> mira cuándo
                        recibiste el dinero.
                    </ManualClave>


                    <ManualEjemplo>

                        <ManualEjemploTitulo>
                            Ejemplo
                        </ManualEjemploTitulo>

                        <ManualEjemploFila>
                            <span>
                                Prestaciones generadas en octubre
                            </span>

                            <strong>
                                $60.000
                            </strong>
                        </ManualEjemploFila>

                        <ManualEjemploFila>
                            <span>
                                Cobrado de prestaciones de octubre
                            </span>

                            <strong>
                                $40.000
                            </strong>
                        </ManualEjemploFila>

                        <ManualEjemploFila>
                            <span>
                                Deuda de septiembre cobrada en octubre
                            </span>

                            <strong>
                                $20.000
                            </strong>
                        </ManualEjemploFila>

                        <ManualEjemploFila>
                            <span>
                                Ingresado durante octubre
                            </span>

                            <strong>
                                $60.000
                            </strong>
                        </ManualEjemploFila>

                        <ManualEjemploFila>
                            <span>
                                Pendiente de octubre
                            </span>

                            <strong>
                                $20.000
                            </strong>
                        </ManualEjemploFila>

                    </ManualEjemplo>


                    <ManualSubtitulo>
                        Cobranza del período
                    </ManualSubtitulo>

                    <ManualTexto>
                        El panel
                        <strong> Cobranza del período</strong>
                        reúne en un mismo lugar:
                        <strong> Importe generado</strong>,
                        <strong>
                            {' '}
                            Cobrado de prestaciones
                        </strong>,
                        <strong>
                            {' '}
                            Ingresado en el período
                        </strong>,
                        <strong>
                            {' '}
                            Pendiente del período
                        </strong> y
                        <strong> Deuda anterior</strong>.
                    </ManualTexto>

                    {renderVolverIndice()}

                </ManualCapitulo>


                <ManualSeparador />


                {/*
                ====================================
                CAPÍTULO 4
                ====================================
                */}

                <ManualCapitulo id="encontrar-deudas">

                    <ManualCapituloNumero>
                        Capítulo 4
                    </ManualCapituloNumero>

                    <ManualCapituloTitulo>
                        Cómo encontrar rápidamente quién te debe
                    </ManualCapituloTitulo>

                    <ManualTexto>
                        Cuando trabajás con
                        <strong> Todos los pacientes</strong>,
                        la sección
                        <strong> Resumen por paciente</strong>
                        permite detectar rápidamente quién
                        tiene deuda y quién está al día.
                    </ManualTexto>

                    <ManualImagen>

                        <img
                            src="/img/tutoriales/cobros-pacientes/08-resumen-por-paciente.png"
                            alt="Resumen por paciente"
                        />

                        <ManualImagenPie>
                            En Resumen por paciente podés filtrar, buscar y
                            comparar rápidamente la situación económica de tus pacientes.
                        </ManualImagenPie>

                    </ManualImagen>

                    <ManualSubtitulo>
                        Activos y Archivados
                    </ManualSubtitulo>

                    <ManualTexto>
                        En <strong>Activos</strong> aparecen
                        los pacientes de tu listado habitual
                        de trabajo.
                    </ManualTexto>

                    <ManualTexto>
                        En <strong>Archivados</strong> podés
                        consultar pacientes que ya no forman
                        parte del listado operativo habitual,
                        manteniendo disponible su información
                        económica histórica.
                    </ManualTexto>


                    <ManualSubtitulo>
                        Filtros
                    </ManualSubtitulo>

                    <ManualDefiniciones>

                        <ManualDefinicion>
                            <ManualDefinicionTitulo>
                                Todos
                            </ManualDefinicionTitulo>

                            <ManualDefinicionTexto>
                                Muestra todos los pacientes de
                                la vista seleccionada.
                            </ManualDefinicionTexto>
                        </ManualDefinicion>

                        <ManualDefinicion>
                            <ManualDefinicionTitulo>
                                Con deuda
                            </ManualDefinicionTitulo>

                            <ManualDefinicionTexto>
                                Muestra pacientes cuyo
                                <strong> Total adeudado</strong>
                                es mayor a $0.
                            </ManualDefinicionTexto>
                        </ManualDefinicion>

                        <ManualDefinicion>
                            <ManualDefinicionTitulo>
                                Al día
                            </ManualDefinicionTitulo>

                            <ManualDefinicionTexto>
                                Muestra pacientes que tuvieron
                                actividad económica pero
                                actualmente no tienen deuda ni
                                saldo a favor.
                            </ManualDefinicionTexto>
                        </ManualDefinicion>

                        <ManualDefinicion>
                            <ManualDefinicionTitulo>
                                Con saldo a favor
                            </ManualDefinicionTitulo>

                            <ManualDefinicionTexto>
                                Muestra pacientes que tienen
                                dinero recibido todavía sin
                                aplicar.
                            </ManualDefinicionTexto>
                        </ManualDefinicion>

                        <ManualDefinicion>
                            <ManualDefinicionTitulo>
                                Sin movimientos
                            </ManualDefinicionTitulo>

                            <ManualDefinicionTexto>
                                Muestra pacientes sin actividad
                                económica para los criterios
                                del período seleccionado.
                            </ManualDefinicionTexto>
                        </ManualDefinicion>

                    </ManualDefiniciones>


                    <ManualSubtitulo>
                        Buscar un paciente
                    </ManualSubtitulo>

                    <ManualTexto>
                        Usá el campo
                        <strong> Buscar paciente...</strong>
                        para escribir parte del nombre o
                        apellido.
                    </ManualTexto>

                    <ManualTexto>
                        El buscador funciona junto con el
                        filtro seleccionado. Por ejemplo,
                        podés elegir
                        <strong> Con deuda</strong> y después
                        buscar un apellido.
                    </ManualTexto>


                    <ManualSubtitulo>
                        Un uso cotidiano
                    </ManualSubtitulo>

                    <ManualPasos>

                        <ManualPaso>
                            <ManualPasoNumero>
                                1
                            </ManualPasoNumero>

                            <ManualPasoTexto>
                                Dejá seleccionado
                                <strong>
                                    {' '}
                                    Todos los pacientes
                                </strong>.
                            </ManualPasoTexto>
                        </ManualPaso>

                        <ManualPaso>
                            <ManualPasoNumero>
                                2
                            </ManualPasoNumero>

                            <ManualPasoTexto>
                                Elegí el período que querés
                                analizar.
                            </ManualPasoTexto>
                        </ManualPaso>

                        <ManualPaso>
                            <ManualPasoNumero>
                                3
                            </ManualPasoNumero>

                            <ManualPasoTexto>
                                Bajá hasta
                                <strong>
                                    {' '}
                                    Resumen por paciente
                                </strong>.
                            </ManualPasoTexto>
                        </ManualPaso>

                        <ManualPaso>
                            <ManualPasoNumero>
                                4
                            </ManualPasoNumero>

                            <ManualPasoTexto>
                                Seleccioná
                                <strong> Con deuda</strong>.
                            </ManualPasoTexto>
                        </ManualPaso>

                        <ManualPaso>
                            <ManualPasoNumero>
                                5
                            </ManualPasoNumero>

                            <ManualPasoTexto>
                                Podés ordenar por
                                <strong> Total adeudado</strong>
                                para ver primero las deudas
                                más altas.
                            </ManualPasoTexto>
                        </ManualPaso>

                    </ManualPasos>

                    {renderVolverIndice()}

                </ManualCapitulo>


                <ManualSeparador />


                {/*
                ====================================
                CAPÍTULO 5
                ====================================
                */}

                <ManualCapitulo id="registrar-cobro">

                    <ManualCapituloNumero>
                        Capítulo 5
                    </ManualCapituloNumero>

                    <ManualCapituloTitulo>
                        Cómo registrar un cobro
                    </ManualCapituloTitulo>

                    <ManualTexto>
                        Cuando un paciente te paga, entrá a
                        su pantalla individual de
                        <strong> Estadísticas y cobros</strong>
                        y seleccioná
                        <strong> Registrar cobro</strong>.
                    </ManualTexto>

                    <ManualClave>
                        <strong>Registrar cobro</strong> sirve
                        para registrar dinero que realmente
                        ingresó. No sirve para indicar que el
                        paciente asistió: eso se registra en
                        el Calendario.
                    </ManualClave>

                    <ManualImagen>

                        <img
                            src="/img/tutoriales/cobros-pacientes/09-registrar-cobro.png"
                            alt="Pantalla Registrar cobro"
                        />

                        <ManualImagenPie>
                            Primero seleccionás las Prestaciones pendientes.
                            Después completás Importe recibido, Fecha del cobro,
                            Medio de pago y, si lo necesitás, una Observación.
                        </ManualImagenPie>

                    </ManualImagen>

                    <ManualSubtitulo>
                        Prestaciones pendientes
                    </ManualSubtitulo>

                    <ManualTexto>
                        En la parte superior aparecen las
                        <strong> Prestaciones pendientes</strong>
                        del paciente.
                    </ManualTexto>

                    <ManualTexto>
                        Cada fila muestra la fecha, el tipo de
                        prestación y el importe que todavía
                        queda pendiente.
                    </ManualTexto>

                    <ManualTexto>
                        Marcá las prestaciones que querés
                        incluir en ese cobro.
                    </ManualTexto>

                    <ManualImportante>
                        La lista puede incluir deuda anterior.
                        No está limitada solamente al período
                        que estabas mirando en la pantalla
                        principal.
                    </ManualImportante>


                    <ManualSubtitulo>
                        Datos del cobro
                    </ManualSubtitulo>

                    <ManualDefiniciones>

                        <ManualDefinicion>
                            <ManualDefinicionTitulo>
                                Importe recibido
                            </ManualDefinicionTitulo>

                            <ManualDefinicionTexto>
                                Escribí cuánto dinero recibiste
                                realmente del paciente.
                            </ManualDefinicionTexto>
                        </ManualDefinicion>

                        <ManualDefinicion>
                            <ManualDefinicionTitulo>
                                Fecha del cobro
                            </ManualDefinicionTitulo>

                            <ManualDefinicionTexto>
                                Indicá el día en que
                                efectivamente recibiste el
                                dinero.
                            </ManualDefinicionTexto>
                        </ManualDefinicion>

                        <ManualDefinicion>
                            <ManualDefinicionTitulo>
                                Medio de pago
                            </ManualDefinicionTitulo>

                            <ManualDefinicionTexto>
                                Actualmente podés elegir
                                <strong> Transferencia</strong>,
                                <strong> Efectivo</strong> o
                                <strong> Mercado Pago</strong>.
                            </ManualDefinicionTexto>
                        </ManualDefinicion>

                        <ManualDefinicion>
                            <ManualDefinicionTitulo>
                                Observación
                            </ManualDefinicionTitulo>

                            <ManualDefinicionTexto>
                                Campo opcional para dejar una
                                aclaración sobre el cobro.
                            </ManualDefinicionTexto>
                        </ManualDefinicion>

                    </ManualDefiniciones>


                    <ManualSubtitulo>
                        Paso a paso
                    </ManualSubtitulo>

                    <ManualPasos>

                        <ManualPaso>
                            <ManualPasoNumero>
                                1
                            </ManualPasoNumero>

                            <ManualPasoTexto>
                                Hacé clic en
                                <strong> Registrar cobro</strong>.
                            </ManualPasoTexto>
                        </ManualPaso>

                        <ManualPaso>
                            <ManualPasoNumero>
                                2
                            </ManualPasoNumero>

                            <ManualPasoTexto>
                                Seleccioná una o más
                                <strong>
                                    {' '}
                                    Prestaciones pendientes
                                </strong>.
                            </ManualPasoTexto>
                        </ManualPaso>

                        <ManualPaso>
                            <ManualPasoNumero>
                                3
                            </ManualPasoNumero>

                            <ManualPasoTexto>
                                Revisá el
                                <strong>
                                    {' '}
                                    Total pendiente seleccionado
                                </strong>.
                            </ManualPasoTexto>
                        </ManualPaso>

                        <ManualPaso>
                            <ManualPasoNumero>
                                4
                            </ManualPasoNumero>

                            <ManualPasoTexto>
                                Completá
                                <strong> Importe recibido</strong>.
                            </ManualPasoTexto>
                        </ManualPaso>

                        <ManualPaso>
                            <ManualPasoNumero>
                                5
                            </ManualPasoNumero>

                            <ManualPasoTexto>
                                Revisá
                                <strong> Fecha del cobro</strong>
                                y elegí el
                                <strong> Medio de pago</strong>.
                            </ManualPasoTexto>
                        </ManualPaso>

                        <ManualPaso>
                            <ManualPasoNumero>
                                6
                            </ManualPasoNumero>

                            <ManualPasoTexto>
                                Si necesitás agregar una
                                aclaración, completá
                                <strong> Observación</strong>.
                            </ManualPasoTexto>
                        </ManualPaso>

                        <ManualPaso>
                            <ManualPasoNumero>
                                7
                            </ManualPasoNumero>

                            <ManualPasoTexto>
                                Hacé clic en
                                <strong> Registrar cobro</strong>.
                            </ManualPasoTexto>
                        </ManualPaso>

                    </ManualPasos>


                    <ManualSubtitulo>
                        Si paga exactamente lo que debe
                    </ManualSubtitulo>

                    <ManualEjemplo>

                        <ManualEjemploTitulo>
                            Ejemplo
                        </ManualEjemploTitulo>

                        <ManualEjemploFila>
                            <span>
                                Pendiente
                            </span>

                            <strong>
                                $20.000
                            </strong>
                        </ManualEjemploFila>

                        <ManualEjemploFila>
                            <span>
                                Importe recibido
                            </span>

                            <strong>
                                $20.000
                            </strong>
                        </ManualEjemploFila>

                        <ManualEjemploFila>
                            <span>
                                Pendiente después del cobro
                            </span>

                            <strong>
                                $0
                            </strong>
                        </ManualEjemploFila>

                    </ManualEjemplo>


                    <ManualSubtitulo>
                        Si paga solo una parte
                    </ManualSubtitulo>

                    <ManualEjemplo>

                        <ManualEjemploTitulo>
                            Ejemplo
                        </ManualEjemploTitulo>

                        <ManualEjemploFila>
                            <span>
                                Pendiente
                            </span>

                            <strong>
                                $20.000
                            </strong>
                        </ManualEjemploFila>

                        <ManualEjemploFila>
                            <span>
                                Importe recibido
                            </span>

                            <strong>
                                $10.000
                            </strong>
                        </ManualEjemploFila>

                        <ManualEjemploFila>
                            <span>
                                Nuevo pendiente
                            </span>

                            <strong>
                                $10.000
                            </strong>
                        </ManualEjemploFila>

                    </ManualEjemplo>


                    <ManualSubtitulo>
                        Si paga varias prestaciones juntas
                    </ManualSubtitulo>

                    <ManualTexto>
                        Podés seleccionar varias
                        prestaciones y registrar un único
                        pago.
                    </ManualTexto>

                    <ManualTexto>
                        YÖGEN distribuye automáticamente el
                        importe entre las prestaciones
                        seleccionadas, comenzando por la deuda
                        más antigua.
                    </ManualTexto>

                    <ManualClave>
                        No tenés que decidir manualmente cuánto
                        aplicar a cada prestación.
                    </ManualClave>


                    <ManualSubtitulo>
                        Si paga más de lo que debe
                    </ManualSubtitulo>

                    <ManualEjemplo>

                        <ManualEjemploTitulo>
                            Ejemplo
                        </ManualEjemploTitulo>

                        <ManualEjemploFila>
                            <span>
                                Total pendiente seleccionado
                            </span>

                            <strong>
                                $30.000
                            </strong>
                        </ManualEjemploFila>

                        <ManualEjemploFila>
                            <span>
                                Importe recibido
                            </span>

                            <strong>
                                $40.000
                            </strong>
                        </ManualEjemploFila>

                        <ManualEjemploFila>
                            <span>
                                Deuda cancelada
                            </span>

                            <strong>
                                $30.000
                            </strong>
                        </ManualEjemploFila>

                        <ManualEjemploFila>
                            <span>
                                Saldo a favor
                            </span>

                            <strong>
                                $10.000
                            </strong>
                        </ManualEjemploFila>

                    </ManualEjemplo>

                    {renderVolverIndice()}

                </ManualCapitulo>


                <ManualSeparador />


                {/*
                ====================================
                CAPÍTULO 6
                ====================================
                */}

                <ManualCapitulo id="historial-cobros">

                    <ManualCapituloNumero>
                        Capítulo 6
                    </ManualCapituloNumero>

                    <ManualCapituloTitulo>
                        Cómo revisar y corregir un cobro
                    </ManualCapituloTitulo>

                    <ManualTexto>
                        Para consultar pagos ya registrados,
                        seleccioná
                        <strong> Historial de cobros</strong>.
                    </ManualTexto>

                    <ManualTexto>
                        Allí vas a encontrar tanto cobros
                        vigentes como cobros que posteriormente
                        fueron anulados.
                    </ManualTexto>

                    <ManualImagen>

                        <img
                            src="/img/tutoriales/cobros-pacientes/10-historial-cobros.png"
                            alt="Historial de cobros"
                        />

                        <ManualImagenPie>
                            Historial de cobros permite revisar movimientos
                            Registrados y Anulados, cuánto fue Aplicado,
                            el Saldo sin aplicar, los Cargos afectados y las
                            Aplicaciones del cobro.
                        </ManualImagenPie>

                    </ManualImagen>

                    <ManualDefiniciones>

                        <ManualDefinicion>
                            <ManualDefinicionTitulo>
                                Registrado
                            </ManualDefinicionTitulo>

                            <ManualDefinicionTexto>
                                El cobro está vigente y forma
                                parte de la situación económica
                                del paciente.
                            </ManualDefinicionTexto>
                        </ManualDefinicion>

                        <ManualDefinicion>
                            <ManualDefinicionTitulo>
                                Anulado
                            </ManualDefinicionTitulo>

                            <ManualDefinicionTexto>
                                El cobro existió pero fue
                                anulado posteriormente. No
                                desaparece del historial.
                            </ManualDefinicionTexto>
                        </ManualDefinicion>

                        <ManualDefinicion>
                            <ManualDefinicionTitulo>
                                Aplicado
                            </ManualDefinicionTitulo>

                            <ManualDefinicionTexto>
                                Indica cuánto de ese cobro fue
                                utilizado para cancelar
                                prestaciones.
                            </ManualDefinicionTexto>
                        </ManualDefinicion>

                        <ManualDefinicion>
                            <ManualDefinicionTitulo>
                                Saldo sin aplicar
                            </ManualDefinicionTitulo>

                            <ManualDefinicionTexto>
                                Es la parte del cobro que
                                todavía no fue utilizada para
                                cancelar deuda.
                            </ManualDefinicionTexto>
                        </ManualDefinicion>

                        <ManualDefinicion>
                            <ManualDefinicionTitulo>
                                Cargos afectados
                            </ManualDefinicionTitulo>

                            <ManualDefinicionTexto>
                                Indica a cuántas prestaciones
                                se aplicó ese cobro.
                            </ManualDefinicionTexto>
                        </ManualDefinicion>

                        <ManualDefinicion>
                            <ManualDefinicionTitulo>
                                Aplicaciones del cobro
                            </ManualDefinicionTitulo>

                            <ManualDefinicionTexto>
                                Muestra exactamente a qué
                                prestación se aplicó el dinero.
                            </ManualDefinicionTexto>
                        </ManualDefinicion>

                    </ManualDefiniciones>


                    <ManualSubtitulo>
                        Me equivoqué al registrar un cobro
                    </ManualSubtitulo>

                    <ManualTexto>
                        Buscá el movimiento dentro de
                        <strong> Historial de cobros</strong>
                        y seleccioná
                        <strong> Corregir cobro</strong>.
                    </ManualTexto>

                    <ManualAdvertencia>
                        <strong>Importante:</strong> no se
                        modifica el cobro anterior por encima.
                        YÖGEN primero anula completamente el
                        cobro y sus aplicaciones, y después
                        permite registrarlo nuevamente con los
                        datos correctos.
                    </ManualAdvertencia>

                    <ManualTexto>
                        El formulario de corrección recupera
                        los datos del cobro anterior para que
                        puedas revisarlos y modifica el botón
                        final a
                        <strong> Guardar corrección</strong>.
                    </ManualTexto>


                    <ManualEjemplo>

                        <ManualEjemploTitulo>
                            Ejemplo
                        </ManualEjemploTitulo>

                        <ManualEjemploFila>
                            <span>
                                Cobro cargado por error
                            </span>

                            <strong>
                                $20.000
                            </strong>
                        </ManualEjemploFila>

                        <ManualEjemploFila>
                            <span>
                                Importe correcto
                            </span>

                            <strong>
                                $15.000
                            </strong>
                        </ManualEjemploFila>

                        <ManualEjemploFila>
                            <span>
                                Cobro anterior
                            </span>

                            <strong>
                                Anulado
                            </strong>
                        </ManualEjemploFila>

                        <ManualEjemploFila>
                            <span>
                                Nuevo cobro
                            </span>

                            <strong>
                                Registrado
                            </strong>
                        </ManualEjemploFila>

                    </ManualEjemplo>

                    {renderVolverIndice()}

                </ManualCapitulo>


                <ManualSeparador />


                {/*
                ====================================
                CAPÍTULO 7
                ====================================
                */}

                <ManualCapitulo id="saldo-favor">

                    <ManualCapituloNumero>
                        Capítulo 7
                    </ManualCapituloNumero>

                    <ManualCapituloTitulo>
                        Saldo a favor
                    </ManualCapituloTitulo>

                    <ManualTexto>
                        El <strong>Saldo a favor</strong> es
                        dinero que ya recibiste del paciente
                        pero que todavía no fue aplicado a una
                        deuda.
                    </ManualTexto>


                    <ManualEjemplo>

                        <ManualEjemploTitulo>
                            Ejemplo
                        </ManualEjemploTitulo>

                        <ManualEjemploFila>
                            <span>
                                Deuda seleccionada
                            </span>

                            <strong>
                                $30.000
                            </strong>
                        </ManualEjemploFila>

                        <ManualEjemploFila>
                            <span>
                                Importe recibido
                            </span>

                            <strong>
                                $40.000
                            </strong>
                        </ManualEjemploFila>

                        <ManualEjemploFila>
                            <span>
                                Saldo a favor generado
                            </span>

                            <strong>
                                $10.000
                            </strong>
                        </ManualEjemploFila>

                    </ManualEjemplo>


                    <ManualSubtitulo>
                        Aplicar a deuda
                    </ManualSubtitulo>

                    <ManualTexto>
                        Si el paciente tiene
                        <strong> Saldo a favor</strong> y al
                        mismo tiempo existe deuda pendiente,
                        aparece el botón
                        <strong> Aplicar a deuda</strong>.
                    </ManualTexto>

                    <ManualTexto>
                        Al seleccionarlo, YÖGEN informa cuánto
                        saldo a favor existe y solicita
                        confirmación.
                    </ManualTexto>

                    <ManualClave>
                        El saldo se aplica automáticamente
                        sobre las <strong>deudas más antiguas</strong>
                        del paciente.
                    </ManualClave>

                    <ManualTexto>
                        No tenés que elegir cuánto dinero
                        aplicar a cada prestación.
                    </ManualTexto>

                    <ManualTexto>
                        Al finalizar, la plataforma informa
                        cuánto saldo fue aplicado y cuánto
                        <strong> Saldo a favor</strong> queda
                        disponible.
                    </ManualTexto>

                    <ManualImportante>
                        Aplicar saldo a favor no genera un
                        nuevo cobro. Utiliza dinero que ya
                        había sido registrado previamente.
                    </ManualImportante>

                    {renderVolverIndice()}

                </ManualCapitulo>


                <ManualSeparador />


                {/*
                ====================================
                CAPÍTULO 8
                ====================================
                */}

                <ManualCapitulo id="no-cobrar">

                    <ManualCapituloNumero>
                        Capítulo 8
                    </ManualCapituloNumero>

                    <ManualCapituloTitulo>
                        Prestaciones que no deben cobrarse
                    </ManualCapituloTitulo>

                    <ManualTexto>
                        Puede ocurrir que una prestación tenga
                        un importe cargado pero finalmente no
                        quieras que genere deuda.
                    </ManualTexto>

                    <ManualTexto>
                        Desde el detalle de las prestaciones,
                        hacé clic sobre la prestación para
                        abrir su
                        <strong> Detalle económico</strong>.
                    </ManualTexto>

                    <ManualTexto>
                        Allí vas a encontrar la opción
                        <strong> Marcar como no cobrar</strong>
                        cuando el cargo está activo.
                    </ManualTexto>

                    <ManualClave>
                        Cuando una prestación se marca como
                        <strong> No cobrar</strong>, conserva
                        su importe histórico pero deja de
                        generar deuda.
                    </ManualClave>


                    <ManualSubtitulo>
                        Volver a cobrar
                    </ManualSubtitulo>

                    <ManualTexto>
                        Si posteriormente necesitás reactivar
                        ese cargo, abrí nuevamente el
                        <strong> Detalle económico</strong> y
                        seleccioná
                        <strong> Volver a cobrar</strong>.
                    </ManualTexto>

                    <ManualTexto>
                        El cargo vuelve a generar deuda.
                    </ManualTexto>


                    <ManualAdvertencia>
                        <strong>
                            ¿Qué pasa si ese cargo ya tiene
                            cobros?
                        </strong>
                        <br />
                        No se puede cambiar a
                        <strong> No cobrar</strong> mientras
                        tenga pagos asociados.
                        Primero tenés que corregir el cobro
                        correspondiente desde
                        <strong> Historial de cobros</strong>.
                    </ManualAdvertencia>

                    {renderVolverIndice()}

                </ManualCapitulo>


                <ManualSeparador />


                {/*
                ====================================
                CAPÍTULO 9
                ====================================
                */}

                <ManualCapitulo id="casos-frecuentes">

                    <ManualCapituloNumero>
                        Capítulo 9
                    </ManualCapituloNumero>

                    <ManualCapituloTitulo>
                        Casos frecuentes
                    </ManualCapituloTitulo>


                    <ManualCaso>

                        <ManualCasoPregunta>
                            El paciente me paga hoy una deuda
                            del mes anterior.
                        </ManualCasoPregunta>

                        <ManualCasoRespuesta>
                            Entrá en
                            <strong> Registrar cobro</strong>.
                            La lista de
                            <strong>
                                {' '}
                                Prestaciones pendientes
                            </strong>
                            puede incluir deuda anterior.
                            Seleccioná la prestación y cargá la
                            fecha en la que recibiste el dinero.
                        </ManualCasoRespuesta>

                    </ManualCaso>


                    <ManualCaso>

                        <ManualCasoPregunta>
                            El paciente paga menos de lo que
                            debe.
                        </ManualCasoPregunta>

                        <ManualCasoRespuesta>
                            Seleccioná la prestación y cargá en
                            <strong> Importe recibido</strong>
                            solamente el dinero que realmente
                            recibiste. El resto continúa
                            pendiente.
                        </ManualCasoRespuesta>

                    </ManualCaso>


                    <ManualCaso>

                        <ManualCasoPregunta>
                            El paciente paga varias sesiones
                            juntas.
                        </ManualCasoPregunta>

                        <ManualCasoRespuesta>
                            Seleccioná varias
                            <strong>
                                {' '}
                                Prestaciones pendientes
                            </strong>
                            y registrá un único cobro. YÖGEN
                            aplica automáticamente el dinero
                            comenzando por la deuda más antigua.
                        </ManualCasoRespuesta>

                    </ManualCaso>


                    <ManualCaso>

                        <ManualCasoPregunta>
                            El paciente paga más de lo que
                            debe.
                        </ManualCasoPregunta>

                        <ManualCasoRespuesta>
                            Registrá el importe realmente
                            recibido. Después de cancelar las
                            prestaciones seleccionadas, el
                            excedente queda como
                            <strong> Saldo a favor</strong>.
                        </ManualCasoRespuesta>

                    </ManualCaso>


                    <ManualCaso>

                        <ManualCasoPregunta>
                            Me equivoqué en el importe de un
                            cobro.
                        </ManualCasoPregunta>

                        <ManualCasoRespuesta>
                            Entrá en
                            <strong> Historial de cobros</strong>,
                            buscá el movimiento y seleccioná
                            <strong> Corregir cobro</strong>.
                        </ManualCasoRespuesta>

                    </ManualCaso>


                    <ManualCaso>

                        <ManualCasoPregunta>
                            El paciente tiene saldo a favor y
                            ahora generó una deuda.
                        </ManualCasoPregunta>

                        <ManualCasoRespuesta>
                            Utilizá
                            <strong> Aplicar a deuda</strong>.
                            El sistema utiliza automáticamente
                            el saldo disponible sobre las
                            deudas más antiguas.
                        </ManualCasoRespuesta>

                    </ManualCaso>


                    <ManualCaso>

                        <ManualCasoPregunta>
                            Una sesión finalmente no debería
                            cobrarse.
                        </ManualCasoPregunta>

                        <ManualCasoRespuesta>
                            Abrí su
                            <strong> Detalle económico</strong>
                            y utilizá
                            <strong>
                                {' '}
                                Marcar como no cobrar
                            </strong>.
                            Si ya tiene pagos asociados,
                            primero tenés que corregir ese
                            cobro.
                        </ManualCasoRespuesta>

                    </ManualCaso>


                    <ManualCaso>

                        <ManualCasoPregunta>
                            El paciente está archivado pero
                            quiero revisar su situación
                            económica.
                        </ManualCasoPregunta>

                        <ManualCasoRespuesta>
                            En
                            <strong> Resumen por paciente</strong>,
                            ingresá a la vista
                            <strong> Archivados</strong>.
                        </ManualCasoRespuesta>

                    </ManualCaso>

                    {renderVolverIndice()}

                </ManualCapitulo>


                <ManualSeparador />


                {/*
                ====================================
                CAPÍTULO 10
                ====================================
                */}

                <ManualCapitulo id="resumen-rapido">

                    <ManualCapituloNumero>
                        Capítulo 10
                    </ManualCapituloNumero>

                    <ManualCapituloTitulo>
                        Resumen rápido
                    </ManualCapituloTitulo>

                    <ManualTexto>
                        Si ya conocés el sistema y solamente
                        necesitás recordar dónde hacer algo,
                        usá esta guía rápida.
                    </ManualTexto>


                    <ManualResumen>

                        <ManualResumenFila>

                            <ManualResumenProblema>
                                Registrar que una sesión ocurrió
                            </ManualResumenProblema>

                            <ManualResumenAccion>
                                Calendario → abrir turno →
                                <strong>
                                    {' '}
                                    Estado del turno: Realizado
                                </strong>
                                → <strong>GUARDAR CAMBIOS</strong>.
                            </ManualResumenAccion>

                        </ManualResumenFila>


                        <ManualResumenFila>

                            <ManualResumenProblema>
                                Ver quién me debe
                            </ManualResumenProblema>

                            <ManualResumenAccion>
                                Estadísticas y cobros →
                                <strong> Todos los pacientes</strong>
                                → Resumen por paciente →
                                <strong> Con deuda</strong>.
                            </ManualResumenAccion>

                        </ManualResumenFila>


                        <ManualResumenFila>

                            <ManualResumenProblema>
                                Registrar un pago
                            </ManualResumenProblema>

                            <ManualResumenAccion>
                                Seleccionar paciente →
                                <strong> Registrar cobro</strong>
                                → elegir prestaciones →
                                completar importe y datos →
                                <strong> Registrar cobro</strong>.
                            </ManualResumenAccion>

                        </ManualResumenFila>


                        <ManualResumenFila>

                            <ManualResumenProblema>
                                Revisar un pago anterior
                            </ManualResumenProblema>

                            <ManualResumenAccion>
                                Seleccionar paciente →
                                <strong>
                                    {' '}
                                    Historial de cobros
                                </strong>.
                            </ManualResumenAccion>

                        </ManualResumenFila>


                        <ManualResumenFila>

                            <ManualResumenProblema>
                                Corregir un pago mal cargado
                            </ManualResumenProblema>

                            <ManualResumenAccion>
                                Historial de cobros →
                                buscar el movimiento →
                                <strong> Corregir cobro</strong>.
                            </ManualResumenAccion>

                        </ManualResumenFila>


                        <ManualResumenFila>

                            <ManualResumenProblema>
                                Usar dinero que quedó a favor
                            </ManualResumenProblema>

                            <ManualResumenAccion>
                                Si existe deuda y
                                <strong> Saldo a favor</strong>,
                                seleccionar
                                <strong> Aplicar a deuda</strong>.
                            </ManualResumenAccion>

                        </ManualResumenFila>


                        <ManualResumenFila>

                            <ManualResumenProblema>
                                Una prestación no se debe cobrar
                            </ManualResumenProblema>

                            <ManualResumenAccion>
                                Abrir la prestación →
                                <strong> Detalle económico</strong>
                                → <strong>Marcar como no cobrar</strong>.
                            </ManualResumenAccion>

                        </ManualResumenFila>


                        <ManualResumenFila>

                            <ManualResumenProblema>
                                Reactivar una prestación
                            </ManualResumenProblema>

                            <ManualResumenAccion>
                                Detalle económico →
                                <strong> Volver a cobrar</strong>.
                            </ManualResumenAccion>

                        </ManualResumenFila>

                    </ManualResumen>


                    <ManualClave>
                        <strong>
                            Para recordar:
                        </strong>
                        {' '}
                        el Calendario genera la actividad,
                        Estadísticas y cobros organiza la
                        deuda y los pagos, y el Historial de
                        cobros conserva la trazabilidad de lo
                        que ocurrió.
                    </ManualClave>

                    {renderVolverIndice()}

                </ManualCapitulo>


            </ManualMain>

        </Cuerpo>

    );

};


export default ManualCobrosPacientes;